<template>
  <div>
    <div class="item">
      <span>订单号：</span>
      <span>{{item.order_sn}} </span>
    </div>
    <div class="item">
      <span>订单金额：</span>
      <span style="color: #ffa380">{{item.order_money}}元</span>
    </div>
    <div class="item">
      <span>项目：</span>
      <span>{{item.order_name}}</span>
    </div>
    <div class="item">
      <span>下单时间：</span>
      <span>{{item.order_time}}</span>
    </div>
    <div class="item">
      <span>是否完成：</span>
      <span>已完成</span>
    </div>
    <div class="item">
      <span>是否入账：</span>
      <span>已入账</span>
    </div>
    <div class="item">
      <span>推广佣金：</span>
      <span style="color: #ffa380">{{item.order_frist_price}}元</span>
    </div>
    <div class="item">
      <span>优惠券：</span>
      <span style="color: #f9647d">{{item.order_coupon_price}}元</span>
    </div>
    <div class="item">
      <span>分成：</span>
      <span style="color: #f9647d">{{item.price}}元</span>
    </div>
  </div>
</template>

<script>
/**
@description:佣金详情
@createTime:2021-09-02
@create:wq
*/
export default {
  name: "",
  props: {},
  components: {},
  data() {
    return {
      item:''
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {
    this.item = this.$route.query.item;
    console.log(this.item);
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.item {
  height: 0.8rem;
  padding: 0 0.24rem;
  display: flex;
  align-items: center;
  font-size: 0.32rem;
  color: #666666;
  span:first-child {
    font-weight: bold;
  }
  &:nth-child(2n + 1) {
    background-color: #f5f5f5;
  }
}
</style>
